"use strict";
// Updated error_utils.ts
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateErrorStringFromError = exports.ErrorCodes = void 0;
var axios_1 = __importDefault(require("axios"));
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["GROUPNAME_NOT_AVAIL"] = 714] = "GROUPNAME_NOT_AVAIL";
    ErrorCodes[ErrorCodes["USERNAME_NOT_AVAIL"] = 713] = "USERNAME_NOT_AVAIL";
    ErrorCodes[ErrorCodes["ORG_NOT_FOUND"] = 400] = "ORG_NOT_FOUND";
    ErrorCodes[ErrorCodes["USER_NOT_VERIFIED"] = 823] = "USER_NOT_VERIFIED";
    ErrorCodes[ErrorCodes["USERNAME_OR_PASSWORD_INCORRECT"] = 604] = "USERNAME_OR_PASSWORD_INCORRECT";
    ErrorCodes[ErrorCodes["MAIL_NOT_VERIFIED"] = 822] = "MAIL_NOT_VERIFIED";
    ErrorCodes[ErrorCodes["ROLE_ALREADY_EXISTS"] = 717] = "ROLE_ALREADY_EXISTS";
    ErrorCodes[ErrorCodes["DATE_OUT_OF_RANGE"] = 800] = "DATE_OUT_OF_RANGE";
    ErrorCodes[ErrorCodes["SHIFT_ASSIGNED_ON_EVENT_DATE"] = 806] = "SHIFT_ASSIGNED_ON_EVENT_DATE";
    ErrorCodes[ErrorCodes["DUPLICATED_EXCHANGE_RESPONSE"] = 833] = "DUPLICATED_EXCHANGE_RESPONSE";
    ErrorCodes[ErrorCodes["REQUEST_NOT_ACCEPT_ONE_FOR_ZERO"] = 834] = "REQUEST_NOT_ACCEPT_ONE_FOR_ZERO";
    ErrorCodes[ErrorCodes["REQUEST_NOT_ACCEPT_ONE_FOR_ONE"] = 835] = "REQUEST_NOT_ACCEPT_ONE_FOR_ONE";
    ErrorCodes[ErrorCodes["BAD_ITR_STATUS"] = 700] = "BAD_ITR_STATUS";
    ErrorCodes[ErrorCodes["USER_ALREADY_ASSIGNED_TO_SLOT"] = 701] = "USER_ALREADY_ASSIGNED_TO_SLOT";
    ErrorCodes[ErrorCodes["USER_NO_PREFRENCE_ON_SLOT"] = 702] = "USER_NO_PREFRENCE_ON_SLOT";
    ErrorCodes[ErrorCodes["USER_NOT_FREE"] = 703] = "USER_NOT_FREE";
    ErrorCodes[ErrorCodes["SLOT_INCOMPATIBLE_WITH_SLOTS"] = 704] = "SLOT_INCOMPATIBLE_WITH_SLOTS";
    ErrorCodes[ErrorCodes["ITR_NOT_LOCKED"] = 705] = "ITR_NOT_LOCKED";
    ErrorCodes[ErrorCodes["USER_NO_ROLE"] = 707] = "USER_NO_ROLE";
    ErrorCodes[ErrorCodes["USER_ALREADY_IN_ITR"] = 708] = "USER_ALREADY_IN_ITR";
    ErrorCodes[ErrorCodes["DELETE_IN_USE_RESOURCE"] = 711] = "DELETE_IN_USE_RESOURCE";
    ErrorCodes[ErrorCodes["NAME_TAKEN"] = 712] = "NAME_TAKEN";
    ErrorCodes[ErrorCodes["MULTIPLE_APPROVED_RESPONSES"] = 719] = "MULTIPLE_APPROVED_RESPONSES";
    ErrorCodes[ErrorCodes["USER_NOT_IN_GROUP"] = 723] = "USER_NOT_IN_GROUP";
    ErrorCodes[ErrorCodes["USER_ALREADY_GROUP_MANAGER"] = 724] = "USER_ALREADY_GROUP_MANAGER";
    ErrorCodes[ErrorCodes["TOO_MANY_USERS_ALREADY_ASSIGNED_TO_SLOT"] = 808] = "TOO_MANY_USERS_ALREADY_ASSIGNED_TO_SLOT";
    ErrorCodes[ErrorCodes["USER_ASSIGNED_TO_OVERLAPPING_SLOT"] = 809] = "USER_ASSIGNED_TO_OVERLAPPING_SLOT";
    ErrorCodes[ErrorCodes["SECTION_RULE_ALREADY_EXISTS"] = 731] = "SECTION_RULE_ALREADY_EXISTS";
    ErrorCodes[ErrorCodes["SLOT_LABEL_RULE_ALREADY_EXISTS"] = 732] = "SLOT_LABEL_RULE_ALREADY_EXISTS";
    ErrorCodes[ErrorCodes["OVERLAPPING_APPROVED_EVENT"] = 820] = "OVERLAPPING_APPROVED_EVENT";
    ErrorCodes[ErrorCodes["MANAGER_ACCESS_CANNOT_GIVE_HIMSELF_ACCESS"] = 836] = "MANAGER_ACCESS_CANNOT_GIVE_HIMSELF_ACCESS";
    ErrorCodes[ErrorCodes["MANAGER_ACCESS_CANNOT_REVOKE_HIMSELF_ACCESS"] = 837] = "MANAGER_ACCESS_CANNOT_REVOKE_HIMSELF_ACCESS";
    ErrorCodes[ErrorCodes["DUPLICATED_EXCHANGE_REQUEST"] = 839] = "DUPLICATED_EXCHANGE_REQUEST";
    ErrorCodes[ErrorCodes["BAD_ITR_START_DATE_COMPARED_TO_CURRENT_ITR"] = 842] = "BAD_ITR_START_DATE_COMPARED_TO_CURRENT_ITR";
})(ErrorCodes || (exports.ErrorCodes = ErrorCodes = {}));
var ErrorCodeToMessage = (_a = {},
    _a[ErrorCodes.GROUPNAME_NOT_AVAIL] = "errors.groupnameNotAvailableError",
    _a[ErrorCodes.USERNAME_NOT_AVAIL] = "errors.emailNotAvailableError",
    _a[ErrorCodes.ORG_NOT_FOUND] = "errors.organizationNotFoundError",
    _a[ErrorCodes.USER_NOT_VERIFIED] = "errors.unverifiedUser",
    _a[ErrorCodes.USERNAME_OR_PASSWORD_INCORRECT] = "errors.incorrectCredentials",
    _a[ErrorCodes.MAIL_NOT_VERIFIED] = "errors.unverifiedMail",
    _a[ErrorCodes.ROLE_ALREADY_EXISTS] = "errors.roleError",
    _a[ErrorCodes.DATE_OUT_OF_RANGE] = "errors.slotDateError",
    _a[ErrorCodes.SHIFT_ASSIGNED_ON_EVENT_DATE] = "errors.shiftAssignedOnEventDate",
    _a[ErrorCodes.DUPLICATED_EXCHANGE_RESPONSE] = "errors.errorNewResponse",
    _a[ErrorCodes.REQUEST_NOT_ACCEPT_ONE_FOR_ZERO] = "errors.errorNewResponse",
    _a[ErrorCodes.REQUEST_NOT_ACCEPT_ONE_FOR_ONE] = "errors.errorNewResponse",
    _a[ErrorCodes.BAD_ITR_STATUS] = "errors.badItrStatus",
    _a[ErrorCodes.USER_ALREADY_ASSIGNED_TO_SLOT] = "errors.userAlreadyAssignedToSlot",
    _a[ErrorCodes.USER_NO_PREFRENCE_ON_SLOT] = "errors.userNoPrefrenceOnSlot",
    _a[ErrorCodes.USER_NOT_FREE] = "errors.userNotFree",
    _a[ErrorCodes.SLOT_INCOMPATIBLE_WITH_SLOTS] = "errors.slotIncompatibleWithSlots",
    _a[ErrorCodes.ITR_NOT_LOCKED] = "errors.itrNotLocked",
    _a[ErrorCodes.USER_NO_ROLE] = "errors.userNoRole",
    _a[ErrorCodes.USER_ALREADY_IN_ITR] = "errors.userAlreadyInItr",
    _a[ErrorCodes.DELETE_IN_USE_RESOURCE] = "errors.deleteInUseResource",
    _a[ErrorCodes.NAME_TAKEN] = "errors.nameTaken",
    _a[ErrorCodes.MULTIPLE_APPROVED_RESPONSES] = "errors.multipleApprovedResponses",
    _a[ErrorCodes.USER_NOT_IN_GROUP] = "errors.userNotInGroup",
    _a[ErrorCodes.USER_ALREADY_GROUP_MANAGER] = "errors.userAlreadyGroupManager",
    _a[ErrorCodes.TOO_MANY_USERS_ALREADY_ASSIGNED_TO_SLOT] = "errors.tooManyUsersAlreadyAssignedToSlot",
    _a[ErrorCodes.USER_ASSIGNED_TO_OVERLAPPING_SLOT] = "errors.userAssignedToOverlappingSlot",
    _a[ErrorCodes.OVERLAPPING_APPROVED_EVENT] = "errors.overlappingApprovedEvent",
    _a[ErrorCodes.MANAGER_ACCESS_CANNOT_GIVE_HIMSELF_ACCESS] = "errors.managerAccessCannotGiveHimselfAccess",
    _a[ErrorCodes.MANAGER_ACCESS_CANNOT_REVOKE_HIMSELF_ACCESS] = "errors.managerAccessCannotRevokeHimselfAccess",
    _a[ErrorCodes.SECTION_RULE_ALREADY_EXISTS] = "errors.sectionRuleAlreadyExists",
    _a[ErrorCodes.SLOT_LABEL_RULE_ALREADY_EXISTS] = "errors.slotLabelRuleAlreadyExists",
    _a[ErrorCodes.DUPLICATED_EXCHANGE_REQUEST] = "errors.duplicatedExchangeRequest",
    _a[ErrorCodes.BAD_ITR_START_DATE_COMPARED_TO_CURRENT_ITR] = "errors.badItrStartDateComparedToCurrentItr",
    _a);
function generateErrorStringFromError(error, defaultError) {
    var _a;
    if (axios_1.default.isAxiosError(error)) {
        var customError = error;
        var errorData = (_a = customError.response) === null || _a === void 0 ? void 0 : _a.data;
        if (errorData === null || errorData === void 0 ? void 0 : errorData.type) {
            return {
                errorKey: ErrorCodeToMessage[errorData.type] || defaultError || "generic.error",
                context: errorData.context,
            };
        }
    }
    // Handle non-Axios or unrecognized errors
    return {
        errorKey: defaultError || "generic.error",
        context: undefined,
    };
}
exports.generateErrorStringFromError = generateErrorStringFromError;
